var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-line 1",
    clipPath: "url(#clip0_13098_11829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0001 15.2165L4.12259 18.5065L5.43509 11.8998L0.489258 7.3265L7.17843 6.53317L10.0001 0.416504L12.8218 6.53317L19.5109 7.3265L14.5651 11.8998L15.8776 18.5065L10.0001 15.2165ZM10.0001 13.3065L13.5393 15.2873L12.7484 11.3098L15.7259 8.55567L11.6984 8.07817L10.0001 4.39567L8.30176 8.079L4.27426 8.55567L7.25176 11.3098L6.46092 15.2873L10.0001 13.3065Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13098_11829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.39c2f1cdddb623dfe60323eb36766b1b.svg";
export { ForwardRef as ReactComponent };